import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageDelivery2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPackageDelivery2"><Path d="M8 3H3V21H14.5147L14 20.4853C11.6569 18.1422 11.6569 14.3432 14 12C15.8946 10.1055 18.741 9.74276 21 10.912V3H16V9H8V3Z" fill="currentColor"/><Path d="M14 3H10V7H14V3Z" fill="currentColor"/><Path d="M21.0711 13.4142C19.509 11.8521 16.9763 11.8521 15.4142 13.4142C13.8522 14.9763 13.8522 17.5089 15.4142 19.071L18.2427 21.8995L21.0711 19.071C22.6332 17.5089 22.6332 14.9763 21.0711 13.4142Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPackageDelivery2;
